module.exports = __webpack_public_path__ + "img/errorbasic.767e9e72.svg";